import { render, staticRenderFns } from "./DashboardPendingIb.vue?vue&type=template&id=555d8055&"
import script from "./DashboardPendingIb.vue?vue&type=script&lang=js&"
export * from "./DashboardPendingIb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports